import saveCustomerInfoForShippingPage from '../../../services/cartAsMandiJob/bdc/_saveCustomerInfoForShippingPage';
import cartAsDesign from '../../../services/cartAsDesign';
import convertDesignToJob from '../../../api/mandi/convertDesignToJob';

export default async (designId, selectedWindows) => {
  if (window.globalConfig.siteId === 3) {
    const job = await convertDesignToJob(designId, [], {}, { mode: 'transient' });
    saveCustomerInfoForShippingPage(job);
  }

  return cartAsDesign(selectedWindows);
};
